export default __webpack_public_path__ + "static/accred_bus_black-2fb459de79b8ca90b6c17606ea27bbc7.jpg";